import React from 'react'
import {
    SlDrawer,
    SlIcon
  } from "@shoelace-style/shoelace/dist/react";
  import { useForm } from "react-hook-form";
  import API from "../../services/api";
  import { Toast } from "../../shared/Toast";

function AddRemainder(props) {
    function handleRequestClose(event) {
        if (event.detail.source === "overlay") {
          event.preventDefault();
        }
      }
      const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm({ mode: "onTouched" });
      const datetoTimestamp = (dateString) => {
        const date = new Date(dateString);
        const timestamp = Math.floor(date.getTime() / 1000);
        return timestamp
      }
      const onSubmit = async(data) =>{
        try {
            let res = await API({
                url:'/accountManagement/add_remainder',
                method:'POST',
                responseType:'json',
                data:{
                    datetime:datetoTimestamp(data.remainder_date),
                    brand_id:props?.brand.brand_id,
                    description:data.description
                }
            })
            if(res.code === 200){
                Toast('success', 'Remainder added successfully!')
                props.setShow(false)
            }
        } catch (error) {
            console.error(error)
        }
      }
  return (
    <div>
         <SlDrawer
        label="POC"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        noHeader={true}>
<div className="px-2 pt-2 relative">
          <h3>Add Remainder</h3>
          <p className="text-gray-500 text-xs my-3">{props?.brand?.name}</p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label className="form-label">Date</label>
              <input
                type="datetime-local"
                className="form-control"
                {...register("remainder_date", {
                  required: { value: true, message: "Date is required!" },
                })}
              ></input>
              {errors.campaign_date && (
                <p className="text-red-600">{errors.remainder_date.message}</p>
              )}
            </div>
            <div className="mb-3">
            <label className="form-label">Description</label>
              <textarea
                className="form-control"
                placeholder="Enter Description"
                {...register("description", {
                  required: { value: true, message: "Description is required!" },
                })}
              ></textarea>
              {errors.description && (
                <p className="text-red-600">{errors.description.message}</p>
              )}
            </div>
            <div className="border-b-[2px] border-dotted mb-3"></div>
            <div>
              <button
                className="w-100 bg-[#0079BC] px-4 py-3 text-white font-bold text-xs rounded "
                type="submit"
              >
                Save Details
              </button>
            </div>
          </form>
          <SlIcon
            className="absolute top-3 right-6 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => props.setShow(false)}
          ></SlIcon>
        </div>
        </SlDrawer>
    </div>
  )
}

export default AddRemainder